import React from 'react'
import { Modal, Typography } from 'antd'
import { QRCodeSVG } from 'qrcode.react'

const { Title, Paragraph } = Typography

const QRCodeModal = ({ visible, onCancel, qrCodeValue }) => (
  <Modal visible={visible} onCancel={onCancel} footer={null} centered width={300}>
    <div style={{ textAlign: 'center', padding: '24px' }}>
      <Title level={4}>Scan to Download</Title>
      <QRCodeSVG value={qrCodeValue} size={200} />
      <Paragraph style={{ marginTop: '16px' }}>Point your camera at the QR code to download the app.</Paragraph>
    </div>
  </Modal>
)

export default QRCodeModal
